/** One shipment's carrier tracking, as the details page collects it per label. */
export type OrderTrackingEntry = {
  _id?: string;
  carrier?: string;
  status?: string;
  message?: string;
  eta?: string;
  totalItems?: number;
};

/** Keyed by carrier, since one order can ship with several. */
export type OrderTrackingMap = Record<string, OrderTrackingEntry[]>;

/** The carrier knows nothing about the number yet, or never will. */
export const UNKNOWN_TRACKING_STATUS = 'UNKNOWN';

export function isKnownTrackingStatus(status?: string) {
  return !!status && status.toUpperCase() !== UNKNOWN_TRACKING_STATUS;
}

/** `OUT_FOR_DELIVERY` is ours to store, not the operator's to read. */
export function formatTrackingStatus(status: string) {
  const words = status.replace(/_/g, ' ').trim().toLowerCase();

  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function getTrackingEntries(
  tracking?: OrderTrackingMap,
): OrderTrackingEntry[] {
  return Object.values(tracking || {}).flat();
}
